<template>
  <div class="row container--stretch">
    <div class="container">
      <h2 class="text-center">Add new corporate</h2>
      <form @submit.prevent="handleSubmit">
        <div class="row">
          <div class="col-lg-12">
            <div class="light a-btn btn-outline no-bg custom_photo_upload p-l-0">
              <div class="profile-avatar-container white b-a b-black logo-preview preview">
                <div class="block custom_photo_upload_btn_wrapper">
                  <div class="dark custom_photo_upload_btn" ref="logoBox" id="pick-avatar">
                    <div class="text-center text-white text-sm image-label">add corporate logo</div>
                  </div>
                  <avatar-cropper
                    @uploading="handleUploading"
                    @completed="handleCompleted"
                    @error="handlerError"
                    trigger="#pick-avatar"
                    :upload-handler="uploadHandler"
                  />
                </div>
              </div>
              <div class="overlay"></div>
            </div>
          </div>
          <div class="col-lg-12 m-b-xs">
            <div class="form-group p-x-sm">
              <input
                :class="{ 'is-invalid': submitted && errors.has('name') }"
                class="md-input"
                id="name"
                name="name"
                type="text"
                v-model="profile.name"
                v-validate="{required:true}"
              />
              <label class="pull-left label-under" style="margin-bottom: 0;" for="name">company name</label>
              <div
                class="invalid-feedback help-block m-t-none parsley-error-list"
                v-if="submitted && errors.has('name')"
              >company name is required.</div>
            </div>
          </div>
          <div class="col-lg-12 m-b-xs">
            <div class="form-group p-x-sm">
              <select
                class="md-input"
                id="industry_id"
                name="industry_id"
                v-validate="{required:true}"
                v-model="profile.industry_id"
              >
                <option value></option>
                <option
                  v-for="industry in industries"
                  :value="industry.id"
                  :key="industry.id"
                >{{industry.name}}</option>
              </select>
              <label
                class="pull-left label-under"
                style="margin-bottom: 0;"
                for="industry_id"
              >industry</label>
              <div
                class="invalid-feedback help-block m-t-none parsley-error-list"
                v-if="submitted && errors.has('industry_id')"
              >industry is required.</div>
            </div>
          </div>
          <div class="col-lg-12 m-b-xs">
            <div class="form-group p-x-sm">
              <select
                class="md-input"
                id="type_id"
                name="type_id"
                v-validate="{required:true}"
                v-model="profile.type_id"
              >
                <option value></option>
                <option v-for="type in orgTypes" :value="type.id" :key="type.id">{{type.name}}</option>
              </select>
              <label class="pull-left label-under" style="margin-bottom: 0;" for="type_id">type</label>
              <div
                class="invalid-feedback help-block m-t-none parsley-error-list"
                v-if="submitted && errors.has('type_id')"
              >type is required.</div>
            </div>
          </div>
          <div class="col-lg-12 m-b-xs">
            <div class="form-group p-x-sm">
              <input
                :class="{ 'is-invalid': submitted && errors.has('reg_number') }"
                class="md-input"
                id="reg_number"
                name="reg_number"
                type="text"
                v-model="profile.reg_number"
                v-validate="{required:isRegistrationNumberRequired}"
              />
              <label
                class="pull-left label-under"
                style="margin-bottom: 0;"
                for="reg_number"
              >co.registration number</label>
              <div
                class="invalid-feedback help-block m-t-none parsley-error-list"
                v-if="submitted && errors.has('reg_number')"
              >co.registration number is required.</div>
            </div>
          </div>
          <div class="col-lg-12 m-b-xs">
            <div class="form-group p-x-sm">
              <vue-tel-input
                ref="phoneNumber"
                class="md-input"
                placeholder
                @validate="validatePhone"
                @input="inputPhone"
                v-model="profile.phone"
                :class="{ 'is-invalid': submitted && errors.has('phone') }"
              ></vue-tel-input>
              <label
                class="pull-left label-under"
                style="margin-bottom: 0;"
                for="reg_number"
              >mobile no.</label>

              <div
                class="invalid-feedback help-block m-t-none parsley-error-list"
                v-if="submitted && error_phone"
              >mobile no. is required.</div>
              <div
                class="invalid-feedback help-block m-t-none parsley-error-list"
                v-else-if="submitted && invalid_phone"
              >mobile no. is invalid.</div>
            </div>
          </div>
          <div class="col-lg-12 m-b-xs">
            <div class="form-group p-x-sm m-t-md m-b text-center" v-if="!$route.params.id">
              <div class="text-xs text-muted">
                By clicking CREATE PROFILE below, you agree to our
                <a
                  class="_600"
                  href="{termsLink}"
                  target="_blank"
                >terms</a> and
                confirm that you have read our
                <a
                  class="_600"
                  href="{privacyLink}"
                  target="_blank"
                >
                  privacy
                  policy
                </a>.
              </div>
            </div>
            <div class="form-group p-x-sm m-t-lg">
              <button class="a-btn btn-block text-white black no-radius text-u-c" type="submit">
                <span class>{{ $route.params.id ? 'Edit profile' : 'Create profile'}}</span>
              </button>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import AvatarCropper from '../../components/form-components/avatar-cropper'
import VueTelInput from 'vue-tel-input'
import ApiService from '../../../../services/ApiService'

export default {
  components: {
    AvatarCropper,
    VueTelInput,
  },
  data() {
    return {
      profile: {
        type: 2,
        name: '',
        reg_number: '',
        industry_id: '',
        type_id: '',
        phone: '',
        public_picture: null,
      },
      logoFile: null,
      submitted: false,
      error_phone: false,
      invalid_phone: false,

      industries: null,
      orgTypes: null,
      countries: null,
      accountService: new ApiService(
        process.env.ACCOUNT_URL,
        window.user.oauth_token
      ),
    }
  },
  created() {
    this.fetchIndustries()
    this.fetchOrgTypes()
    this.fetchCountries()
  },
  computed: {
    isRegistrationNumberRequired() {
      let optionalForTypes = [6 /** Government */, 7 /** Unregistered */]
      return !optionalForTypes.includes(this.profile.type_id)
    },
  },
  methods: {
    validatePhone(e) {
      this.invalid_phone = !e.isValid
    },
    inputPhone(e) {
      this.error_phone = e === ''
    },
    handleUploading(event) {},
    handleCompleted(data) {
      this.profile.public_picture = data.data.public_picture
      this.fillImage(this.profile.public_picture)
    },
    handlerError(err) {
      console.log(err)
    },
    uploadHandler(cropper) {
      cropper
        .getCroppedCanvas({
          type: Object,
          default() {
            return {
              width: 512,
              height: 512,
            }
          },
        })
        .toBlob((blob) => {
          this.logoFile = blob
          let reader = new FileReader()
          reader.readAsDataURL(this.logoFile)
          reader.onload = (e) => {
            this.fillImage(e.target.result)
          }
        })
    },
    fetchIndustries() {
      this.accountService
        .get(`/api/industries`)
        .then((res) => (this.industries = res.data))
    },
    fetchOrgTypes() {
      this.accountService
        .get(`/api/corporate-types`)
        .then((res) => (this.orgTypes = res.data))
    },
    fetchCountries() {
      this.accountService
        .get(`/api/countries`)
        .then((res) => (this.countries = res.data))
    },

    handleSubmit(e) {
      this.submitted = true
      this.$validator.validate().then((valid) => {
        if (valid) {
          this.accountService
            .post(`/api/profiles`, this.transformToFormData())
            .then((res) => {
              this.$toaster.success(
                'The corporate profile has been added successfully'
              )
              window.location.assign(
                `${window.user.community_url}/${window.user.community_domain}/account/getCommunityProfile?profile_id=${res.data.profile_id}&type=${res.data.type}`
              )
            })
        }
      })
    },
    uploadImage(event) {
      let reader = new FileReader()
      this.logoFile = event.srcElement.files[0]

      reader.readAsDataURL(this.logoFile)
      reader.onload = (e) => {
        this.fillImage(e.target.result)
      }
    },
    transformToFormData() {
      let formData = new FormData()
      for (let key in this.profile) {
        formData.append(key, this.profile[key])
      }

      if (this.logoFile) formData.append('logo', this.logoFile, 'a.jpg')
      return formData
    },
    addErrors(error) {
      error.response.data.errors.forEach((errorData) => {
        this.$validator.errors.add({
          field: errorData.field,
          msg: errorData.messages[0],
        })
      })
    },

    fillImage(imageUrl) {
      this.$refs.logoBox.style =
        'background: url(' + imageUrl + ') no-repeat;background-size: cover;'
    },
  },
}
</script>


<style lang="scss">
.is-invalid {
  border-bottom: 1px solid rgba(255, 0, 0, 0.6) !important;
}

.form-group {
  max-width: 400px;
  margin: 0 auto;
}

.md-input {
  border: none;
  border-bottom: 1px solid rgba(160, 160, 160, 0.6);
  width: 100%;
  height: 34px;
  padding: 2px;
}

.vue-tel-input {
  border: none !important;
  border-bottom: 1px solid rgba(160, 160, 160, 0.6) !important;
  width: 100%;
  height: 34px;
  padding: 2px;
}
.vue-tel-input:focus-within {
  box-shadow: none !important;
  border: none !important;
  border-bottom: 1px solid rgba(160, 160, 160, 0.6) !important;
  width: 100%;
  height: 34px;
  padding: 2px;
}

.form-group .label-under {
  opacity: 0.6;
  position: relative;
  text-transform: lowercase;
  left: 0;
  top: 0;
  font-size: 0.85em;
  margin-bottom: 0.5rem;
  color: rgba(0, 0, 0, 0.87);
  line-height: 1.5;
  font-family: 'Roboto', 'Helvetica Neue', Helvetica, Arial, sans-serif;
}

.md-input:focus {
  border-color: rgba(120, 130, 140, 0.87);
  border-bottom-width: 2px;
  padding-bottom: 1px;
}

.m-t-md {
  margin-top: 1.5rem !important;
}

.m-b {
  margin-bottom: 1rem !important;
}

.text-center {
  text-align: center;
}

.m-t-lg {
  margin-top: 3rem !important;
  margin-bottom: 1rem;
}

.a-btn {
  color: #fff !important;
  border-radius: 0 !important;
  background-color: #2a2b3c;
  font-weight: 500;
  outline: 0 !important;
  text-transform: uppercase;
  display: block;
  width: 100%;
  line-height: 1.25;
  text-align: center;
  white-space: nowrap;
  vertical-align: middle;
  cursor: pointer;
  user-select: none;
  border: 1px solid transparent;
  padding: 0.5rem 1rem;
  font-size: 1rem;
}

.btn:hover {
  color: rgba(255, 255, 255, 0.87) !important;
  background-color: #2a2b3c;
  text-decoration: none;
}

.custom_photo_upload {
  position: relative;
}

.no-bg {
  background-color: transparent !important;
}

.light {
  /* background-color: #f8f8f8; */
}

.m-t,
.m-y {
  margin-top: 1rem !important;
}

.btn-outline {
  border-width: 1px !important;
  -webkit-box-shadow: none !important;
  box-shadow: none !important;
}

.a-btn {
  font-weight: 500;
  outline: 0 !important;
}

.btn-outline,
.label.no-bg {
  background-color: transparent;
}

.p-l-0 {
  padding-left: 0 !important;
}

.a-btn {
  display: inline-block;
  font-weight: 400;
  line-height: 1.25;
  text-align: center;
  white-space: nowrap;
  vertical-align: middle;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  border: 1px solid transparent;
  padding: 0.5rem 1rem;
  font-size: 1rem;
  border-radius: 0.25rem;
}

.custom_photo_upload .preview.logo-preview {
  background-image: url(http://accounts.local/images/organization_default.jpg);
}

.custom_photo_upload .preview {
  width: 130px !important;
  border-style: dashed !important;
  background: no-repeat center !important;
  background-size: cover !important;
}

.b-black {
  border-color: #2a2b3c !important;
}

.b-a {
  border: 1px solid rgba(120, 130, 140, 0.13);
}

.custom_photo_upload .preview .custom_photo_upload_btn_wrapper {
  position: relative;
  width: 128px;
  height: 128px;
  vertical-align: middle;
}

.block {
  display: block;
}

.custom_photo_upload
  .preview
  .custom_photo_upload_btn_wrapper
  .custom_photo_upload_btn {
  position: relative;
  width: 128px;
  height: 128px;
  vertical-align: middle;
}

.custom_photo_upload_btn {
  opacity: 0.7;
  filter: alpha(opacity=0);
  -webkit-animation: 1s ease 0s normal forwards 1 fadein;
  animation: 1s ease 0s normal forwards 1 fadein;
}

.dark {
  background-color: #2e3e4e;
  color: rgba(255, 255, 255, 0.87);
}

.custom_photo_upload .preview.logo-preview .image-label {
  position: relative !important;
  top: 40% !important;
}

.text-sm {
  font-size: 0.8rem;
  text-transform: lowercase;
}

.text-white {
  color: #fff !important;
}

.text-center {
  text-align: center;
}

.custom_photo_upload input.upload {
  position: absolute;
  top: 0;
  left: 0;
  margin: 0;
  padding: 0;
  font-size: 12px;
  cursor: pointer;
  opacity: 0;
  filter: alpha(opacity=0);
  height: 100% !important;
}

.invalid-feedback {
  display: block;
  clear: both;
}
.profile-avatar-container {
  margin: 0 auto;
}
@media (min-width: 768px) {
  .profile-avatar-container {
    position: relative;
    left: calc(50% + 250px);
    margin: 0 0 -190px;
  }
}
</style>
